export const sizing = {
  axisLabel: '{axis} ({value} units)',
  overwriteLength: 'Change length together with scale X',
  overwriteScaleX: 'Change scale X together with length',
  overwriteHeight: 'Change height together with scale Y',
  overwriteScaleY: 'Change scale Y together with height',
  overwrtiteWidth: 'Change width together with scale Z',
  overwriteScaleZ: 'Change scale Z together with width',
  sceneResizeRequired:
    'Scale and size editing is locked. Change scene size if the object is too small or too large.',
} as const
